// lifePolicyEntryDashEndPoint.js
import { baseApi } from '../baseApi';

export const lifePolicyEntryDashApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({

        getLifePolicyEntries: builder.query({
            query: (params = {}) => {
                if (typeof params === 'string') {
                    return {
                        url: '/dashboard/life-policy-entries',
                        method: 'GET',
                        params: { filterType: params },
                    };
                }
                return {
                    url: '/dashboard/life-policy-entries',
                    method: 'GET',
                    params: {
                        ...params,
                        pageNumber: params.pageNumber ?? 1,
                        pageSize: params.pageSize ?? 30,
                    },
                };
            },
        }),

        getLifePremiumsDue: builder.query({
            query: (params = {}) => {
                if (typeof params === 'string') {
                    return {
                        url: '/dashboard/life-premiums-due',
                        method: 'GET',
                        params: { filterType: params },
                    };
                }
                return {
                    url: '/dashboard/life-premiums-due',
                    method: 'GET',
                    params: {
                        ...params,
                        pageNumber: params.pageNumber ?? 1,
                        pageSize: params.pageSize ?? 30,
                    },
                };
            },
        }),

    }),
});

export const {
    useGetLifePolicyEntriesQuery,
    useLazyGetLifePolicyEntriesQuery,   // ← used by TablesView for infinite scroll

    useGetLifePremiumsDueQuery,
    useLazyGetLifePremiumsDueQuery,     // ← used by TablesView for infinite scroll
} = lifePolicyEntryDashApi;